import { FileMetadata, ZipListFile } from "../models/fileSystem";
import api from "./index";

const BASE = "/files";

export const uploadFile = async (file: File): Promise<FileMetadata> => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await api.post(`${BASE}/upload`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        return response.data as FileMetadata;
    } catch (error) {
        console.error("Failed to upload file:", error);
        throw error;
    }
};

export const listFiles = async (): Promise<FileMetadata[]> => {
    try {
        const response = await api.get(BASE);
        return response.data as FileMetadata[];
    } catch (error) {
        console.error("Failed to list files:", error);
        throw error;
    }
};

export const downloadFile = async (filename: string): Promise<void> => {
    try {
        const response = await api.get(`${BASE}/${filename}`, {
            responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Failed to download file:", error);
        throw error;
    }
};

export const deleteFile = async (filename: string): Promise<void> => {
    try {
        await api.delete(`${BASE}/${filename}`);
    } catch (error) {
        console.error("Failed to delete file:", error);
        throw error;
    }
};
export const uploadZipList = async (
    file: File,
    offerId: number
): Promise<void> => {
    try {
        const ext = file.name.split(".").pop()?.toLowerCase();

        if (!["csv", "xlsx"].includes(ext || "")) {
            throw new Error("Only CSV or XLSX files are allowed");
        }

        const formData = new FormData();
        formData.append("file", file);

        const response = await api.post(`${BASE}/upload_ziplist/${offerId}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        return response.data;
    } catch (error) {
        console.error("Failed to upload ZipList file:", error);
        throw error;
    }
};
export const editZipList = async (
    file: File,
    offerId: number
): Promise<void> => {
    try {
        const ext = file.name.split(".").pop()?.toLowerCase();

        if (!["csv", "xlsx"].includes(ext || "")) {
            throw new Error("Only CSV or XLSX files are allowed");
        }
        const formData = new FormData();
        formData.append("file", file);

        const response = await api.put(
            `${BASE}/edit_ziplist/${offerId}`,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" }
            }
        );

        return response.data;
    } catch (error) {
        console.error("Failed to edit ZipList file:", error);
        throw error;
    }
};

export const downloadZipList = async (offerId: number): Promise<void> => {
    try {
        const response = await api.get(`${BASE}/get_ziplist/${offerId}`, {
            responseType: "blob",
        });

        let filename = "ziplist";
        const cd = response.headers["content-disposition"];
        if (cd) {
            const match = cd.match(/filename="?([^"]+)"?/);
            if (match && match[1]) filename = match[1];
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Failed to download ZipList file:", error);
        throw error;
    }
};

export const deleteZipList = async (offerId: number): Promise<void> => {
    try {
        await api.delete(`${BASE}/delete_ziplist/${offerId}`);
    } catch (error) {
        console.error("Failed to delete ZipList file:", error);
        throw error;
    }
};

export const uploadSpec = async (
    file: File,
    filename: string
): Promise<void> => {
    try {
        const ext = file.name.split(".").pop()?.toLowerCase();

        if (!["html"].includes(ext || "")) {
            throw new Error("Only HTML files are allowed");
        }

        const formData = new FormData();
        formData.append("file", file);

        const response = await api.post(`${BASE}/upload_spec/${filename}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        return response.data;
    } catch (error) {
        console.error("Failed to upload spec file:", error);
        throw error;
    }
};

export const deleteSpecFile = async (filename: string): Promise<void> => {
    try {
        await api.delete(`${BASE}/delete_spec/${filename}`);
    } catch (error) {
        console.error("Failed to delete spec file:", error);
        throw error;
    }
};
